import React from 'react';

import { Icon } from '@components/atoms';
import { css } from '@emotion/core';
import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import { color } from '@styles/themes';
import { Select as ASelect, SelectProps } from 'antd';

export type TSelect = SelectProps<any>;

const { Option: ASelectOption } = ASelect;

const tYzTypeSelect = ['TRANSPARENT'] as const;
type TYzTypeSelect = typeof tYzTypeSelect[number];
type THandleSelectWithType = { yzTypeSelect?: TYzTypeSelect };
const handleSelectWithType = ({ yzTypeSelect }: THandleSelectWithType) => {
  switch (yzTypeSelect) {
    case 'TRANSPARENT':
      return css`
        background: transparent;
        margin: 0px 10px;
        color: ${color.gray10};
        .ant-select-selector {
          background: transparent !important;
        }
        .ant-select-arrow {
          color: ${color.gray10};
        }
      `;
    default:
      return css``;
  }
};

interface ISelect extends TSelect {
  yzTypeSelect?: TYzTypeSelect;
}
const StyledSelect = styled(ASelect, { shouldForwardProp: isPropValid })<ISelect>`
  height: 36px;
  box-shadow: none !important;

  .ant-select-selector {
    height: 100% !important;
    box-shadow: none !important;
    padding: 0 32px 0 12px !important;
    display: flex;
    align-items: center;
  }

  .ant-select-selection-item {
    padding-right: 0 !important;
    line-height: 37px !important;
  }

  .ant-select-selection-search-input {
    height: 100% !important;
  }

  .ant-select-arrow {
    vertical-align: -10px !important;
  }
  ${({ yzTypeSelect }) => handleSelectWithType({ yzTypeSelect })}
`;

export const Select = ({ ...rest }) => <StyledSelect suffixIcon={<Icon icon="ico16ArrowUp" />} {...rest} />;

export const SelectOption = styled(ASelectOption)``;
